export class PropertyErrorModel {
	public propertyName = '';
	public errorCode = '';
	public message = '';
	public severity = '';

	public static readonly ERROR_STATE_INFO = 'info';
	public static readonly ERROR_STATE_WARNING = 'warning';
	public static readonly ERROR_STATE_ERROR = 'error';

	constructor(init?: Partial<PropertyErrorModel>) {
		Object.assign(this, init);
	}
}
